const defaultSort = null;

const initialState = {
  editing: false,
  shopperList: [],
  searchTerm: '',
  sortTerm: defaultSort,
  sortDirection: false,
  totalShoppers: 0,
  page: 1,
  totalPages: 0,
  shopper: {},
  error: false,
  view: 'shoppers',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SHOPPERS_KEYS':
      return {
        ...state,
        ...action.payload,
      };
    case 'CLEAR_AGENT_LEADS':
      return initialState;
    case 'CLEAR_SHOPPERS':
      return initialState;
    default:
      return state;
  }
};
